import { connect } from "react-redux";
import useActionLock from "../../hooks/useActionLock";

const Dialog = ({
  title,
  showCloseIcon = true,
  children,
  onClose,
  onSave,
  onCancel,
  showCancelButton = true,
  showSaveButton = true,
  customClasses = "",
  width = "w-[350px]",
  showButtons = true,
  cancelButtonTitle = "Cancel",
  saveButtonTitle = "Save",
  buttonAlignment = "between",
  saveButtonColor,
  titleClasses,
  saveButtonClasses = "",
  saveButtonDisabled,
  user,
}) => {
  const [locked, runAction] = useActionLock();
  const language = user?.language;

  const buttonAlignmentClass =
    buttonAlignment === "between" ? "justify-between" : "justify-evenly";

  const handleOutsideClick = (e) => {
    if (e.target.id === "default-modal") {
      onClose();
    }
  };

  return (
    <div
      onClick={handleOutsideClick}
      id="default-modal"
      tabIndex="-1"
      aria-hidden="true"
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        className={`bg-white p-4 rounded-[10px] shadow-custom ${width} ${customClasses}`}
      >
        {title && showCloseIcon ? (
          <div
            className={`flex justify-start items-center mb-4 ${titleClasses}`}
          >
            {title && (
              <h2 className="text-base text-start font-semibold">{title}</h2>
            )}
            {showCloseIcon && (
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
            )}
          </div>
        ) : (
          <div
            className={`flex justify-center items-center mb-4 ${titleClasses}`}
          >
            {title && <h2 className="text-base font-bold">{title}</h2>}
            {showCloseIcon && (
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
            )}
          </div>
        )}

        <div className="mb-4">{children}</div>

        {showButtons && (
          <div
            className={`flex ${
              language === "ARABIC" ? "flex-row" : "flex-row"
            } ${buttonAlignmentClass} `}
          >
            {showCancelButton && (
              <button
                onClick={onCancel}
                className="font-bold text-sm text-quaternary border-none focus:outline-none focus:border-none uppercase"
              >
                {cancelButtonTitle}
              </button>
            )}
            {showSaveButton && (
              <button
                disabled={saveButtonDisabled || locked}
                onClick={() => runAction(async () => { if (onSave) await onSave(); })}
                className={`${
                  saveButtonColor ? saveButtonColor : "text-colPrimary"
                } 
              font-bold text-sm border-none focus:outline-none uppercase ${saveButtonClasses} ${
                  saveButtonDisabled && "!text-[#2D9CDB80]"
                }`}
              >
                {saveButtonTitle}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ authentication }) => ({
  user: authentication.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);
